// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHappyPowerLoyaltyInvertedIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12m2.87 7.5a.5.5 0 0 0-.411.216 2.997 2.997 0 0 1-4.92 0 .5.5 0 0 0-.821.568 4 4 0 0 0 2.977 1.703h.61a4 4 0 0 0 2.978-1.703.5.5 0 0 0-.41-.784zM9.5 10a1.5 1.5 0 0 0-1.414 2h2.828A1.5 1.5 0 0 0 9.5 10m5 0a1.5 1.5 0 0 0-1.414 2h2.828a1.5 1.5 0 0 0-1.414-2"
    />
    <path
      fillRule="evenodd"
      d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-7 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
    />
  </g>
);
export default SvgHappyPowerLoyaltyInvertedIcon;
SvgHappyPowerLoyaltyInvertedIcon.displayName = 'SvgHappyPowerLoyaltyInvertedIcon';
